import TableWithSelection from 'components/abmUtils/TableWithSelection'
import {
	IPricesListsMassiveUpdateTableProps,
	IPricesListsMassiveUpdateTableState
} from 'models/PricesListsMassiveUpdate'
import { ITableWithSelectionFields } from 'models/TableWithSelection'
import React, { Component } from 'react'
import { Alert, Col } from 'react-bootstrap'
import { TransProps, withTranslation } from 'react-i18next'

class PricesListsMassiveUpdateTable extends Component<
	IPricesListsMassiveUpdateTableProps & TransProps,
	IPricesListsMassiveUpdateTableState
> {
	constructor(props: IPricesListsMassiveUpdateTableProps) {
		super(props)
		this.state = {
			showEditPopup: false
		}
	}

	render() {
		const { t, tableFields, fields, handleChangeTable, gridFilters } =
			this.props

		const propsTable: ITableWithSelectionFields = {
			headerFilters: gridFilters,
			tableFields: tableFields,
			fields: fields ? fields.lista : [],
			disableForm: false,
			selected: [],
			setSelection: () => {},
			handleChangeTable: handleChangeTable,
			label: 'Ejemplo',
			keyfield: 'niprod',
			checkBox: false,
			hideHeaderButtons: true,
			paginationOption: fields && {
				page_size: fields.page_size,
				page_number: fields.page_number,
				total_count: fields.total_count
			},
			hideScrollX: true,
			hideScrollY: false
		}

		return (
			<Col>
				<Alert variant={'dark'}>
					<b>{t('CRUDS.general_use.products_list')}</b>
				</Alert>
				<TableWithSelection {...propsTable} />
			</Col>
		)
	}
}

export default withTranslation()(PricesListsMassiveUpdateTable)
